import { render, staticRenderFns } from "./AuthSignupView.vue?vue&type=template&id=12d18036&scoped=true"
import script from "./AuthSignupView.vue?vue&type=script&lang=js"
export * from "./AuthSignupView.vue?vue&type=script&lang=js"
import style0 from "./AuthSignupView.vue?vue&type=style&index=0&id=12d18036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d18036",
  null
  
)

export default component.exports